import { FileUpload } from "@mui/icons-material";
import { blue } from "@mui/material/colors";
import React, { useEffect, useState } from "react";

import NoImage from "../../../assets/images/addimage.png"
import { Button } from "react-bootstrap";

import { UPDATE_PRODUCTS, GET_PRODUCTS, APP_BASE_URL } from "../../AppConstant";
import LoadingGif from "../../../assets/images/Spin_loader.gif"
import axios from "axios";

function UpdateProductPage({ setParentLoading }) {
    const [imagePreview, setImagePreview] = useState(NoImage);

    const [productName, setProductName] = useState("");
    const [productCount, setProductCount] = useState("");
    const [productFile, setProductFile] = useState(null);

    const [message, setMessage] = useState("");
    const [Errormessage, setErrorMessage] = useState("");

    const [products, setProducts] = useState([]);
    const [productId, setProductId] = useState("");

    const [isEditing, setIsEditing] = useState(false);

    const fetchProducts = async () => {
        try {
            setParentLoading(true);
            const res = await axios.get(GET_PRODUCTS);
            setProducts(res.data);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        } catch (err) {
            console.error(err);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    const handleEdit = (item) => {
        setParentLoading(true);
        setProductId(item.id);
        setProductName(item.name);
        setProductCount(item.count);

        const imageUrl =
            APP_BASE_URL + "/products/getproductimage/" + item.id;

        const img = new Image();

        img.onload = () => {
            setImagePreview(imageUrl);
            setIsEditing(true);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        };

        img.onerror = () => {
            setImagePreview(NoImage);
            setIsEditing(true);
            console.error("Failed to load image");
             setTimeout(() => {
                setParentLoading(false);
            }, 500);
        };

        img.src = imageUrl;
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        const allowedTypes = ["image/jpeg", "image/png"];

        if (!allowedTypes.includes(file.type)) {
            setErrorMessage("Only JPG, JPEG, PNG files are allowed");
            setProductFile(null);
            setImagePreview(NoImage);
            return;
        }

        const imageUrl = URL.createObjectURL(file);

        setErrorMessage("");
        setProductFile(file);
        setImagePreview(imageUrl);
    };

    const BtnUpdateProduct = async (e) => {
        setParentLoading(true);
        e.preventDefault();

        if (!productId || !productName || !productCount) {
            setErrorMessage("Please fill required fields");
            setMessage("");
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            return;
        }

        const formData = new FormData();
        formData.append("id", productId);
        formData.append("count", productCount)
        formData.append("name", productName);

        if (productFile) {
            formData.append("file", productFile);
        }

        try {
            await axios.post(UPDATE_PRODUCTS, formData);

            setErrorMessage("");
            setMessage("Product updated successfully");

            fetchProducts();

            setProductName("");
            setProductCount("");
            setProductFile(null);
            setImagePreview(NoImage);

            setIsEditing(false);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);

        } catch (error) {
            if (error.response?.data?.error) {
                setErrorMessage(error.response.data.error);
            } else {
                setErrorMessage("Error updating product");
            }
            setMessage("");
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        }
    };



    return (
        <div>

            <div className="row">

                <div className="col-8">
                    <form action="" method="POST">
                        <div className="form-group">
                            <label for="name">Product Name</label>
                            <input type="text" className="form-control" name="name" id="productname" value={productName} onChange={(e) => setProductName(e.target.value.toUpperCase())} disabled={!isEditing}></input>
                        </div>

                        <div className="form-group">
                            <label for="name">Product Count</label>
                            <input type="number" className="form-control" name="count" id="productcount" maxLength={3} value={productCount} onChange={(e) => setProductCount(e.target.value)} disabled={!isEditing}></input>
                        </div>

                        <div className="form-group">
                            <label for="name">Product Image</label>
                            <input type="file" className="form-control" name="file" id="productfile" key={productFile ? productFile.name : "no-file"} onChange={handleFileChange} accept=".jpg,.jpeg,.png,.jfif" disabled={!isEditing}></input>
                        </div>

                        {isEditing && <Button className="btn btn-success m-2" onClick={BtnUpdateProduct}>UPDATE</Button>}


                        {message && (
                            <p style={{ color: "green", fontWeight: "bold" }}>
                                {message}
                            </p>
                        )}


                        {Errormessage && (
                            <p style={{ color: "red", fontWeight: "bold" }}>
                                {Errormessage}
                            </p>
                        )}


                    </form>
                </div>

                <div className="col-4">
                    <img
                        src={imagePreview}
                        alt="Preview"
                        style={{ width: "100%", objectFit: "contain", height: "150px" }}
                    />
                </div>
            </div>


            <table className="mt-3 fw-bold">
                <thead className="bg-primary" style={{ color: "var(--bs-white)" }} >
                    <tr>
                        <th>S.No</th>
                        <th>Product Name</th>
                        <th>Product Count</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody className="text-secondary" style={{ fontSize: "small" }}>
                    {products.map((item, index) => (
                        <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>
                            <td>{item.count}</td>
                            <td>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => handleEdit(item)}
                                >
                                    MOVE TO EDIT
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>


        </div>

    )
}

export default UpdateProductPage;